import React from "react";
import { cn } from "@/lib/utils";

export function SealBadge({ children, className, pulse = false, ...props }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-md bg-[hsl(var(--brand-vermillion))] text-white px-2 py-1 text-xs font-semibold shadow-sm",
        pulse && "seal-pulse",
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
}

export function PaperSection({ children, className, id }) {
  return (
    <section
      id={id}
      className={cn(
        "relative rounded-2xl bg-card/90 border border-border shadow-[0_10px_30px_rgba(20,18,12,0.06)] p-5 sm:p-8",
        className
      )}
    >
      {children}
    </section>
  );
}

export function SectionTitle({ zh, en, lang, kicker, className }) {
  return (
    <div className={cn("mb-6", className)}>
      {kicker && (
        <div className="text-xs uppercase tracking-[0.2em] text-[hsl(var(--brand-bronze))] font-semibold mb-2">
          {kicker}
        </div>
      )}
      <h2 className="font-display text-2xl md:text-3xl font-semibold text-foreground">
        {lang === "zh" ? zh : en || zh}
      </h2>
    </div>
  );
}

export function Price({ value, className }) {
  return (
    <span className={cn("font-mono-num font-semibold", className)}>
      RM{Number(value || 0).toFixed(2)}
    </span>
  );
}

export function CloudDivider({ className }) {
  return (
    <div className={cn("flex items-center justify-center gap-2 opacity-40 my-2", className)}>
      <span className="h-px w-16 bg-[hsl(var(--brand-gold))]" />
      <svg width="34" height="14" viewBox="0 0 34 14" fill="none" className="text-[hsl(var(--brand-gold))]">
        <path d="M2 10c3 0 3-4 6-4s3 4 6 4 3-6 6-6 3 6 6 6" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
      </svg>
      <span className="h-px w-16 bg-[hsl(var(--brand-gold))]" />
    </div>
  );
}
